import React, { useState, useEffect } from 'react';
import { userService } from '../../../api';
import './users.css';
import Sidebar from '../sidebar/Sidebar';

const Users = () => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState({
    name: '',
    location: ''
  });

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    filterUsers();
  }, [searchTerm, users]);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await userService.getAll();
      setUsers(response.data || []);
    } catch (err) {
      setError(err.message || 'Erreur lors du chargement des utilisateurs');
    } finally {
      setLoading(false);
    }
  };

  const filterUsers = () => {
    const filtered = users.filter(user => {
      const matchesName = user.name.toLowerCase().includes(searchTerm.name.toLowerCase());
      const matchesLocation = user.ville?.toLowerCase().includes(searchTerm.location.toLowerCase()) || false;
      
      // Si les deux champs de recherche sont vides, afficher tous les utilisateurs
      if (!searchTerm.name && !searchTerm.location) return true;
      
      // Si seul le nom est recherché
      if (searchTerm.name && !searchTerm.location) return matchesName;
      
      // Si seule la localisation est recherchée
      if (!searchTerm.name && searchTerm.location) return matchesLocation;
      
      // Si les deux champs sont remplis
      return matchesName && matchesLocation;
    });
    
    setFilteredUsers(filtered);
  };

  const handleDeleteUser = async (userId) => {
    if (!window.confirm('Êtes-vous sûr de vouloir supprimer cet utilisateur ?')) {
      return;
    }

    try {
      await userService.delete(userId);
      await fetchUsers(); // Rafraîchir la liste après suppression
    } catch (err) {
      setError(err.message || 'Erreur lors de la suppression');
    }
  };

  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    setSearchTerm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  if (loading) return (
    <div className="admin-container">
      <Sidebar />
      <div className="loading">Chargement...</div>
    </div>
  );
  
  if (error) return (
    <div className="admin-container">
      <Sidebar />
      <div className="error">Erreur: {error}</div>
    </div>
  );

  return (
    <div className="admin-container">
      <Sidebar />
      <div className="main-content">
        <h2>Liste des utilisateurs</h2>
        
        {/* Barre de recherche */}
        <div className="search-filters">
          <div className="search-input">
            <label htmlFor="name">Recherche par nom :</label>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Entrez un nom..."
              value={searchTerm.name}
              onChange={handleSearchChange}
            />
          </div>
          
          <div className="search-input">
            <label htmlFor="location">Recherche par localisation :</label>
            <input
              type="text"
              id="location"
              name="location"
              placeholder="Entrez une ville..."
              value={searchTerm.location}
              onChange={handleSearchChange}
            />
          </div>
        </div>
        
        <div className="users-grid">
          {filteredUsers.length > 0 ? (
            filteredUsers.map((user) => (
              <div key={user.id} className="user-card">
                <div className="user-header">
                  <h3>{user.name}</h3>
                  <span className={`role-badge ${user.role}`}>{user.role}</span>
                </div>
                
                <div className="user-info">
                  <p><strong>Email:</strong> {user.email}</p>
                  <p><strong>Ville:</strong> {user.ville || 'Non spécifié'}</p>
                  <p><strong>Inscrit le:</strong> {new Date(user.created_at).toLocaleDateString()}</p>
                  <p><strong>Email vérifié:</strong> {user.email_verified_at ? 'Oui' : 'Non'}</p>
                </div>
                
                <div className="user-details">
                  <details>
                    <summary>Plus d'informations</summary>
                    <p><strong>Bio:</strong> {user.bio || 'Aucune'}</p>
                    <p><strong>Compétences:</strong> {user.competences ? JSON.parse(user.competences).join(', ') : 'Aucune'}</p>
                    <p><strong>Besoins:</strong> {user.besoins ? JSON.parse(user.besoins).join(', ') : 'Aucun'}</p>
                  </details>
                </div>
                
                <button 
                  onClick={() => handleDeleteUser(user.id)}
                  className="delete-btn"
                >
                  Supprimer
                </button>
              </div>
            ))
          ) : (
            <div className="no-users">
              {users.length === 0 ? 'Aucun utilisateur trouvé' : 'Aucun résultat correspondant à votre recherche'}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Users;